import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Teach tailwind-merge the custom shadow and text-size names so they are not mistaken
// for colours and dropped when two classes meet.
const merge = extendTailwindMerge({
  extend: {
    classGroups: {
      shadow: [{ shadow: ["ring", "ring-hairline", "ring-inset", "button", "button-primary", "button-light", "button-danger", "tile", "tile-raised", "modal", "popover", "selected", "rail-active"] }],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => merge(clsx(inputs));

/** Base UI parts take className as a string or a function of state; keep that shape while prepending ours. */
export const withBase = <State,>(
  base: string,
  className: string | ((state: State) => string | undefined) | undefined,
): string | ((state: State) => string) =>
  typeof className === "function" ? (state) => cn(base, className(state)) : cn(base, className);
